// Events are added here only when genuinely confirmed (real date, time, place).
// Currently none are scheduled — the Events page shows an honest empty state.
export const events = [];
